import type { MODULATOR_DETAILS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulator-details-card/modulator-details-card.fr.ts";

export const MODULATOR_DETAILS_CARD_ENGLISH_LOCALE = {
  title: "Modulator details",
  location: "Location",
  serialNumber: "Serial number",
  hardwareId: "Hardware Id",
  site: "Site",
  csId: "Cs Id",
  pilot: "Pilot",
  neuronId: "Neuron Id",
  type: "Type",
} satisfies typeof MODULATOR_DETAILS_CARD_FRENCH_LOCALE;
